import React from "react";
import Select from 'react-select'
import useAuth from "./hooks/useAuth";
import { useEffect, useState } from "react";

const CheckUserLanguages = ({ selectHandler, checkuser }) => {
  const {auth, setAuth} = useAuth();
  const [data, setData] = useState()
  const [loading, setLoading] = useState(true)

  // Country flag mapping for common languages
  const getFlagEmoji = (language) => {
    const flagMap = {
      'English': '🇬🇧', // Changed from 🇺🇸 to 🇬🇧
      'Spanish': '🇪🇸',
      'French': '🇫🇷',
      'German': '🇩🇪',
      'Italian': '🇮🇹',
      'Portuguese': '🇵🇹',
      'Russian': '🇷🇺',
      'Chinese': '🇨🇳',
      'Japanese': '🇯🇵',
      'Korean': '🇰🇷',
      'Arabic': '🇸🇦',
      'Hindi': '🇮🇳',
      'Turkish': '🇹🇷',
      'Dutch': '🇳🇱',
      'Polish': '🇵🇱',
      'Ukrainian': '🇺🇦',
      'Greek': '🇬🇷',
      'Hebrew': '🇮🇱',
      'Swedish': '🇸🇪',
      'Norwegian': '🇳🇴',
      'Danish': '🇩🇰',
      'Finnish': '🇫🇮',
      'Czech': '🇨🇿',
      'Hungarian': '🇭🇺',
      'Romanian': '🇷🇴',
      'Bulgarian': '🇧🇬',
      'Serbian': '🇷🇸',
      'Croatian': '🇭🇷',
      'Slovak': '🇸🇰',
      'Slovenian': '🇸🇮',
      'Estonian': '🇪🇪',
      'Latvian': '🇱🇻',
      'Lithuanian': '🇱🇹',
      'Icelandic': '🇮🇸',
      'Maltese': '🇲🇹',
      'Macedonian': '🇲🇰',
      'Albanian': '🇦🇱',
      'Bosnian': '🇧🇦',
      'Montenegrin': '🇲🇪',
      'Belarusian': '🇧🇾',
      'Georgian': '🇬🇪',
      'Armenian': '🇦🇲',
      'Azerbaijani': '🇦🇿',
      'Kazakh': '🇰🇿',
      'Uzbek': '🇺🇿',
      'Turkmen': '🇹🇲',
      'Kyrgyz': '🇰🇬',
      'Tajik': '🇹🇯',
      'Mongolian': '🇲🇳',
      'Vietnamese': '🇻🇳',
      'Thai': '🇹🇭',
      'Indonesian': '🇮🇩',
      'Malay': '🇲🇾',
      'Filipino': '🇵🇭',
      'Burmese': '🇲🇲',
      'Cambodian': '🇰🇭',
      'Lao': '🇱🇦',
      'Bangla': '🇧🇩',
      'Urdu': '🇵🇰',
      'Persian': '🇮🇷',
      'Pashto': '🇦🇫',
      'Kurdish': '🇮🇶',
      'Swahili': '🇰🇪',
      'Amharic': '🇪🇹',
      'Yoruba': '🇳🇬',
      'Zulu': '🇿🇦',
      'Afrikaans': '🇿🇦',
      'Somali': '🇸🇴',
      'Igbo': '🇳🇬',
      'Oromo': '🇪🇹',
      'Hausa': '🇳🇬',
      'Malagasy': '🇲🇬',
      'Chichewa': '🇲🇼',
      'Kinyarwanda': '🇷🇼',
      'Kirundi': '🇧🇮',
      'Sesotho': '🇱🇸',
      'Setswana': '🇧🇼',
      'Xhosa': '🇿🇦'
    };
    
    return flagMap[language] || '🌐'; // Default globe emoji for unknown languages
  };

  const getFiles = async () => {
    setLoading(true);
    const fetchData = async (route, method) => {
      const token = localStorage.getItem("token");
      const url = `${process.env.REACT_APP_USER_API_URL}/analysis/${route}` 
      const response = await fetch(url, {
          method: method,
          headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
          }
      });
      if (response.status === 401) {
          localStorage.removeItem("token");
          setAuth({});
          return null;
      }
      if (response.ok) {
          const json = await response.json();
          return json;
      }
      return null
    }
    
    var json = ""
    if (checkuser) {
      json = await fetchData(`list_languages?checkuser=${checkuser}`, "GET");
    } else {
      json = await fetchData(`list_languages`, "GET");
    }
    
    if (json) {
        let languages = []
        json.map((item,i)=>{
          languages.push({
            'value': item, 
            'label': `${getFlagEmoji(item)} ${item}`,
            'flag': getFlagEmoji(item)
          })
        })
        setData(languages);
    }
    setLoading(false);
  }

  useEffect(()=>{getFiles()},[checkuser])

  if (loading) return ( 
    <div className="flex items-center justify-center py-3">
      <div className="flex items-center gap-2 text-gray-500">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
        <span className="text-sm">Loading languages...</span>
      </div>
    </div>
  )

  if (!data || data.length === 0) return (
    <div className="text-center py-3 text-gray-500 text-sm">
      No languages available
    </div>
  )

  // Custom component for displaying options with flags
  const formatOptionLabel = ({ value, label, flag }) => (
    <div className="flex items-center gap-2">
      <span className="text-lg">{flag}</span>
      <span>{value}</span>
    </div>
  );

  return (
    <Select 
      onChange={selectHandler}
      options={data}
      formatOptionLabel={formatOptionLabel}
      placeholder="Select language..."
      className="text-sm"
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: '44px',
          borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
          borderRadius: '8px',
          backgroundColor: 'white',
          boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
          '&:hover': {
            borderColor: state.isFocused ? '#3b82f6' : '#9ca3af'
          },
          transition: 'all 0.2s ease-in-out'
        }),
        menu: (base) => ({
          ...base,
          borderRadius: '8px',
          border: '1px solid #e5e7eb',
          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
          zIndex: 50
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#eff6ff' : 'white',
          color: state.isSelected ? 'white' : '#374151',
          fontSize: '14px',
          padding: '8px 12px',
          '&:active': {
            backgroundColor: '#2563eb'
          }
        }),
        placeholder: (base) => ({
          ...base,
          color: '#9ca3af',
          fontSize: '14px'
        }),
        singleValue: (base) => ({
          ...base,
          color: '#374151',
          fontSize: '14px',
          fontWeight: '500',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }),
        dropdownIndicator: (base, state) => ({
          ...base,
          color: state.isFocused ? '#6b7280' : '#9ca3af',
          '&:hover': {
            color: '#6b7280'
          }
        }),
        indicatorSeparator: (base) => ({
          ...base,
          backgroundColor: '#e5e7eb'
        })
      }}
    />
  );
};

export default CheckUserLanguages;